// hooks
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';

// components
import SmallIcon from '../../SmallIcon';

// assets
import { AppStoreIcon, BlogIcon, FacebookIcon, InstagramIcon } from '../../../assets/icons';
import PlayStore from '../../../assets/icons/play-store.svg';

export default function FooterResponsive() {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();
  const currentLang = i18n.language;

  const socialIcons = [
    {
      icon: <InstagramIcon />,
      href: 'https://www.instagram.com/usa2georgia.com_/'
    },
    {
      icon: <FacebookIcon />,
      href: 'https://www.facebook.com/USA2GEORGIACOM/'
    },
    {
      icon: <BlogIcon />,
      href: `https://news.usa2georgia.com/${currentLang === 'ka' ? '' : currentLang}`
    }
  ];
  return (
    <div className='responsive-footer flex-column'>
      <div className='d-flex mb-5 justify-content-between'>
        <a href='https://apps.apple.com/us/app/usa2georgia/id1461461537' target='_blank' rel='noreferrer'>
          <AppStoreIcon />
        </a>
        <a href='https://play.google.com/store/apps/details?id=com.usa2georgia.usa2georgia' target='_blank' rel='noreferrer'>
          <img src={PlayStore} alt='play-store' />
        </a>
      </div>
      <div className='d-flex responsive-footer-div justify-content-between'>
        <div>
          <Link target='_blank' to={'/agreement/' + i18n.language}>
            <p className='login-footer-terms color-gray cursor-pointer font-size-14'>{t('_TERMS_AGGREMENT')}</p>
          </Link>
          <Link target='_blank' to='/user-policy'>
            <p className='login-footer-terms color-gray cursor-pointer font-size-14'>{t('_USER_POLICY')}</p>
          </Link>
          <p className='login-copyright'>
            {currentYear} {t('_COPYRIGHT')}
          </p>
        </div>
        <div className='ms-4 d-flex'>
          {socialIcons.map((item, index) => (
            <a className='ms-2' key={index} href={item.href} target='_blank' rel='noreferrer'>
              <SmallIcon imgStyle='social-img-sizes' img={item.icon} bg='icon-dark-bg' />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
